import { useKeycloak } from "@josempgon/vue-keycloak"
import User from '@/models/user.model'
import packageInfo from '../../../package.json'

export default {
  data () {
    return {
      user: new User(),
      username: useKeycloak().decodedToken.value.family_name,
      loaded: false,
      errorMessage: null,
      version : packageInfo.version,
    }
  },

  created () {
    this.user.login = this.username
    if(!sessionStorage.getItem('user')) {
      if (this.user.login != null || this.user.login === '') {
        this.$store.dispatch('auth/login', this.user).then(
          () => {
            this.$router.push('home')
            this.loaded = true
          },
          error => {
            if (this.username === null || this.username === '') {
              this.$router.replace('/')
            }
            this.errorMessage = error.response.data
          }
        )
      }
      else {
        // Needs to be redirected to login page
        this.$router.replace('/')
      }
    }
    else {
      this.loaded = true
      this.user = JSON.parse(sessionStorage.getItem('user'))
    }
  }
}
